// extracted by mini-css-extract-plugin
module.exports = {"Technology":"Technology_Technology__Rg4kH"};